import { createAction } from '@reduxjs/toolkit';

export const setSelectedRailsSandbox = createAction('setSelectedRailsSandbox', (params) => ({
  payload: params,
}));
